import { useEffect, useSyncExternalStore } from 'react';
import type { SiteDataSnapshot } from '../site-data/site-data-snapshot';
import {
    readClientSiteData,
    readServerSiteData,
    revalidateSiteData,
    subscribeSiteData
} from '../site-data/site-data-store';

/**
 * The specialists and services, available on the first render — see `site-data-store`.
 *
 * The server snapshot is the build's copy, so hydration adopts the prerendered markup; when the
 * live copy differs, React re-renders straight after with it.
 */
export function usePublicSiteData(): SiteDataSnapshot {
    const snapshot = useSyncExternalStore(subscribeSiteData, readClientSiteData, readServerSiteData);

    useEffect(() => revalidateSiteData(), []);

    return snapshot;
}
